<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @closed="closed"
             width="600px">
    <div style="margin: 20px 110px 0 80px">
      <el-form label-position="right" label-width="90px" :model="warehousePos" :rules="rules" ref="warehousePos">
        <input-form-item label="库位编号" prop="code"></input-form-item>
        <input-form-item label="库位名称" prop="name"></input-form-item>
        <remote-form-item label="库位类型" class-name="WAREHOUSE_POS_TYPE" prop="typeCode" using-code></remote-form-item>
        <remote-form-item label="入库仓库" prop="warehouseId" class-name="Warehouse"></remote-form-item>
        <textarea-form-item label="备注" prop="remarks"></textarea-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()">新 增</el-button>
      <el-button v-else-if="!readOnly" type="primary" @click="save()">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

import InputFormItem from '@/components/form/InputFormItem'
import TextareaFormItem from '@/components/form/TextareaFormItem'
import RemoteFormItem from '@/components/form/RemoteFormItem'

export default {
  name: 'EditWarehousePosDialog',
  components: {
    RemoteFormItem,
    TextareaFormItem,
    InputFormItem
  },
  props: {
    warehousePos: {
      type: Object,
      required: true
    },
    readOnly: Boolean
  },
  data () {
    return {
      rules: {
        name: [
          {
            required: true,
            message: '请输入库位名称',
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入库位编号',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    closed () {
      if (!this.readOnly) {
        this.$refs.warehousePos.resetFields()
      }
    },
    add () {
      this.$refs.warehousePos.validate(valid => {
        if (!valid) return

        this.$store.dispatch('warehousePos/add', this.$_.cloneDeep(this.warehousePos)).then(() => {
          this.hide()
          this.$message.success('添加成功!')
        })
      })
    },
    save () {
      this.$refs.warehousePos.validate(valid => {
        if (!valid) return

        this.$store.dispatch('warehousePos/updateOne', this.$_.cloneDeep(this.warehousePos)).then(() => {
          this.hide()
        })
      })
    },
    cancel () {
      this.hide()
    },
    hide () {
      this.$emit('update:visible', false)
    }
  },
  computed: {
    isNew () {
      return !this.warehousePos.id
    },
    controlReadOnly () {
      return !this.isNew && this.readOnly
    },
    title () {
      if (this.isNew) return '新增库位'
      return this.readOnly ? '库位详细信息' : '编辑库位'
    }
  }
}
</script>
